import { render, staticRenderFns } from "./TotalRankingCard.vue?vue&type=template&id=2dea3c09&"
import script from "./TotalRankingCard.vue?vue&type=script&lang=js&"
export * from "./TotalRankingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports